import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"chart-minimum"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M21 21H3V3","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M7 4.00567C7 7.99233 7.99609 13.9999 13 14.0038C18.0039 14.0077 19 7.98833 19 4M6.99805 16.998H7.00195V17.002H6.99805V16.998ZM9.99805 16.998H10.002V17.002H9.99805V16.998ZM12.998 16.998H13.002V17.002H12.998V16.998ZM15.998 16.998H16.002V17.002H15.998V16.998ZM18.998 16.998H19.002V17.002H18.998V16.998Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const ChartMinimum = Vue.extend<IconProps>({
  name: 'ChartMinimumIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'chart-minimum',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default ChartMinimum;
